import { api } from './api'

const INSIGHTS_ENDPOINT = process.env.VUE_APP_AFFILIATE_INSIGHTS_ENDPOINT || '/api/affiliate/insights'
const ACCOUNTS_ENDPOINT = process.env.VUE_APP_AFFILIATE_ACCOUNTS_ENDPOINT || '/api/affiliate/accounts'
const LICENSE_ENDPOINT = process.env.VUE_APP_AFFILIATE_LICENSE_ENDPOINT || '/api/affiliate/license'
const EXTEND_TRIAL_ENDPOINT = process.env.VUE_APP_AFFILIATE_EXTEND_TRIAL_ENDPOINT || '/api/affiliate/accounts/extend-trial'
const ACCOUNT_STATUS_ENDPOINT = process.env.VUE_APP_AFFILIATE_ACCOUNT_STATUS_ENDPOINT || '/api/affiliate/accounts/update-status'
const AFFILIATE_LINK_ENDPOINT = process.env.VUE_APP_AFFILIATE_LINK_ENDPOINT || '/api/affiliate/link'
const AFFILIATE_LINK_BASE = process.env.VUE_APP_AFFILIATE_LINK_BASE || ''
const SERIALS_ENDPOINT = process.env.VUE_APP_AFFILIATE_SERIALS_ENDPOINT || '/api/affiliate/serials'

export const insights = {
  async getAccountCounts() {
    const { data } = await api.get(INSIGHTS_ENDPOINT)
    return {
      total: data?.totalAccounts ?? 0,
      paid: data?.paidAccounts ?? 0,
      trial: data?.trialAccounts ?? 0,
      canceled: data?.canceledAccounts ?? 0,
    }
  },
  async getAccounts() {
    const { data } = await api.get(ACCOUNTS_ENDPOINT)
    // Expect an array of accounts with { id, name, email, phone, status, trialEndAt, createdAt }
    return Array.isArray(data) ? data : (data?.items || [])
  },
  async createAccount(accountData) {
    const { data } = await api.post(ACCOUNTS_ENDPOINT, accountData)
    return data
  },
  async getSerials() {
    const { data } = await api.get(SERIALS_ENDPOINT)
    // Expect an array of serials with { id, serial_key, status, created_at, updated_at, affiliate_id }
    return Array.isArray(data) ? data : (data?.items || [])
  },
  async generateLicenseKey(accountId) {
    // Try API first
    try {
      const body = (accountId === undefined || accountId === null) ? {} : { accountId }
      const { data } = await api.post(LICENSE_ENDPOINT, body)
      // Expect { key: string }
      if (data && data.key) return data.key
    } catch (e) {
      // ignore and fallback
    }
    // Fallback local key generator: 5 groups x 5 chars (A-Z,0-9), e.g. GSKY9-4TQ2P-1MZ8X-7R6VW-5H3ND
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const group = () => Array.from({ length: 5 }, () => alphabet[Math.floor(Math.random() * alphabet.length)]).join('')
    return `${group()}-${group()}-${group()}-${group()}-${group()}`
  },
  async extendTrial(accountId, days) {
    try {
      const { data } = await api.post(EXTEND_TRIAL_ENDPOINT, { accountId, days })
      // Expect { trialEndAt }
      if (data && data.trialEndAt) return data.trialEndAt
    } catch (e) {
      // ignore and fallback
    }
    // Fallback: today + days
    const base = new Date()
    base.setDate(base.getDate() + Number(days || 0))
    return base.toISOString().slice(0, 10)
  },
  async updateAccountStatus(accountId, status) {
    try {
      const { data } = await api.post(ACCOUNT_STATUS_ENDPOINT, { accountId, status })
      // Expect { status }
      if (data && data.status) return data.status
    } catch (e) {
      // ignore and fallback
    }
    // Fallback: echo back
    return status
  },
  async getAffiliateLink() {
    // Try API endpoint first, expect { link } or { code }
    try {
      const { data } = await api.get(AFFILIATE_LINK_ENDPOINT)
      if (data?.link) return data.link
      if (data?.code) {
        return `https://l.gstocky.com?ref=${encodeURIComponent(data.code)}`
      }
    } catch (e) {
      localStorage.removeItem('affiliate_email')
      localStorage.removeItem('affiliate_token')
      this.$router.push('/login')
      // ignore and fallback
    }
    // Fallback: build from email local part or a random code
    const email = localStorage.getItem('affiliate_email') || ''
    const code = (email.split('@')[0] || 'affiliate').toUpperCase()
    const origin = AFFILIATE_LINK_BASE || (window?.location?.origin || '')
    return origin ? `${origin}?ref=${encodeURIComponent(code)}` : `?ref=${encodeURIComponent(code)}`
  },
  async loginAsUser(accountId) {
    const { data } = await api.post(`/api/affiliate/accounts/${accountId}/login-as`)
    return data
  }
}
